import { Radio, RadioGroup } from '@fluentui/react-components';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PermissionScope } from '../../../../../../../api/types.gen';
import { IPermissionsDialogForm } from '../../../PermissionsDialogForm';
import { PermissionsHStack } from '../../PermissionsHStack';
import { PermissionsField } from '../PermissionsField';

export function PermissionsDeleteGroup() {
  const { t } = useTranslation();
  const { control } = useFormContext<IPermissionsDialogForm>();
  return (
    <PermissionsField label={t('permissions.modifyAction.deleteGroup.label')}>
      <Controller
        control={control}
        name="deleteItems"
        render={({ field: { value, onChange } }) => (
          <RadioGroup>
            <PermissionsHStack>
              <Radio
                label={t('permissions.modifyAction.deleteGroup.options.none')}
                checked={value === PermissionScope.NONE}
                value={PermissionScope.NONE}
                onChange={(_, d) => {
                  onChange(d.value);
                }}
              />
              <Radio
                label={t('permissions.modifyAction.deleteGroup.options.own')}
                checked={value === PermissionScope.OWNED}
                value={PermissionScope.OWNED}
                onChange={(_, d) => {
                  onChange(d.value);
                }}
              />
              <Radio
                label={t('permissions.modifyAction.deleteGroup.options.all')}
                checked={value === PermissionScope.ALL}
                value={PermissionScope.ALL}
                onChange={(_, d) => {
                  onChange(d.value);
                }}
              />
            </PermissionsHStack>
          </RadioGroup>
        )}
      />
    </PermissionsField>
  );
}
